import { useCallback } from 'react';
import userApi from 'api/userApi';

/**
 * useLogout
 * - 서버 로그아웃 호출 후 로컬 세션 정리를 수행합니다.
 * - onAfterLogout 콜백에서 앱 상태 초기화를 수행하세요.
 */
export default function useLogout({ user, onAfterLogout }) {
  return useCallback(async () => {
    try {
      if (user && user.userId) {
        await userApi.logout(user.userId);
      }
    } catch (error) {
      console.error('로그아웃 API 호출 오류:', error);
    } finally {
      localStorage.removeItem('userToken');
      if (onAfterLogout) {
        onAfterLogout();
      }
    }
  }, [user, onAfterLogout]);
}
